import styled from '@emotion/styled'
import tw from 'twin.macro'

// export const FeatureRowFlex = styled.div`
//   ${tw`
//     lg:mt-20
//     lg:flex
//     lg:flex-wrap
//     lg:w-full
//     lg:justify-between
//   `}
// `

export const FeatureRowGrid = styled.div`
  ${tw`
    lg:grid
    lg:mt-16
  `}
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 2fr 1fr;
  }
`

export const FeatureTitle = styled.div`
  h3 {
    ${tw`
      pl-4
      text-lg
      leading-6
      text-green-500
      border-l-4 
      border-green-500
    `}
  }
  h3.authentication {
    ${tw`
      text-blue-500
      border-blue-500
    `}
  }
  h3.enterprise-connections {
    color: #7872fb;
    border-color: #7872fb;
  }
`

export const FeatureDescription = styled.div`
  ${tw`
    pl-4
    pr-8
  `}
  p {
    ${tw`
      text-base
      leading-6
      text-gray-500
    `}
  }
  a {
    ${tw`
      pl-4
      mt-2
      text-base
      text-teal-500
    `}
  }
`

export const FeatureImage = styled.div`
  .feature {
    ${tw`
      rounded-lg
      shadow-lg
      object-cover
      object-center
    `}
  }
`
